<template lang="html">
    <entity-page id="page__lathing" v-bind:loading="progress">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <div class="row">
            <z-input-autocomplete
                v-model="price.city_id" v-on:select="selectCity" class="col-6" id="city__id"  name="city_id"
                property="id" return="id" label="Населённый пункт (город/посёлок/село/...)" display-property="label"
                v-bind:callback="getCities" v-bind:default="(price.city && price.city.name) ? price.city.name : ''"
                v-validate="'required'" v-bind:error="errors.first('city_id')" data-vv-name="city_id" v-bind:data-vv-as="' '"
            ></z-input-autocomplete>
            <z-input
                v-model="price.price" label="Стоимость обрешётки за 1м<sup>3<sup>" name="price" id="price" class="col-6"
                v-validate="{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="true" 
                v-bind:error="errors.first('price')" type="number" data-vv-name="price" v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                v-model="price.volume_min" label="Минимальный объём" name="volume_min" id="volume_min" class="col-6"
                v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" v-bind:required="true" 
                v-bind:error="errors.first('volume_min')" type="number" data-vv-name="volume_min" v-bind:data-vv-as="' '"
            ></z-input>

            <z-input
                v-model="price.price_min" label="Стоимость за минимальный объём" name="price_min" id="price_min" class="col-6"
                v-validate="{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}" v-bind:required="true" 
                v-bind:error="errors.first('price_min')" type="number" data-vv-name="price_min" v-bind:data-vv-as="' '"
            ></z-input>
        </div>
    </entity-page>
</template>
<script>
    import ZInputAutocomplete from '@/components/ZInputAutocomplete'
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
    export default {
        components: { ZInputAutocomplete, ZInput, ZSelect, EntityPage, ZIconButton },
        data() {
            return {
                price: {},
                priceDefault: {
                    id: null,
                    city_id: null,
                    price: null,
                    price_min: null,
                    volume_min: null
                },
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-price-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        created() {
            this.init();
        },
        methods: {
            /**
             * Возврат пользователя на предидущую страницу
             */
            back() {
                this.$router.push({name: 'DoomPrices', query: this.$route.query});
            },
            /**
             * Инициализация компонента
             */
            init() {
                this.$store.commit('openRightPanel');
                if (this.$route.params.id && this.$route.params.id != 'new') this.getPrice(this.$route.params.id).then(price => {
                    this.price = Object.assign({}, price);
                });
                else this.price = Object.assign({}, this.priceDefault);
            },
            /**
             * Получение цены
             */
            getPrice(id) {
                this.$store.commit('showProgressBar', 'load-price-card');
                return this.$store.dispatch('cost/getDoomPrice', { id: id }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Сохранение цены
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    if (this.$route.params.id != 'new') this.putPrice();
                    else this.postPrice();
                })
            },
            /**
             * Добавление цены
             */
            postPrice() {
                this.$store.commit('showProgressBar', 'load-price-card');
                this.$store.dispatch('cost/postDoomPrice', this.price).then((r) => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'doomprices');
                    this.$router.push({name: 'DoomPrice', params: {id: r.id}})
                }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Изменение цены
             */
            putPrice () {
                this.$store.commit('showProgressBar', 'load-price-card');
                this.$store.dispatch('cost/putDoomPrice', this.price).then((r) => {
                    if (!r) return;
                    this.getPrice(r.id);
                    this.$root.$emit('reload-table', 'doomprices');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Автозаполнение города
             */
            getCities(searchString) {
                if (searchString.length >= 3) return this.$store.dispatch('stock/getCities', { name: searchString }).then( async r => {
                    if (!r || !r.length) r = [];

                    r.map(item => Object.assign(item, {
                        value: item.value || item.name,
                        label: item.value || item.name
                    }));

                    return r.concat(await this.suggestCity(searchString, r.map(item => item.name)))
                });
            },
            /**
             * Предложение города
             */
            suggestCity(searchString, existsNames) {
                return this.$store.dispatch('cost/suggestCity', { string: searchString }).then(r => {
                    if (!r || !r.length) return [];
                    return r.filter(item => !item.data.street)
                        .filter(item => item && (!item.data.city || item.data.settlement))
                        .filter(item => !!item.unrestricted_value)
                        .map(item => {
                            return {
                                name:       item.data.settlement ? (item.data.settlement + ' ' + item.data.settlement_type) : (item.data.city + ' ' + item.data.city_type),
                                aouguid:    item.data.settlement_fias_id ? item.data.settlement_fias_id : item.data.city_fias_id,
                                okato:      item.data.okato,
                                parentguid: (item.data.region_fias_id) ? item.data.region_fias_id : null,
                                id:         null,
                                disid:      null,
                                zone_id:    null,
                                regioncode: null,
                                label: item.unrestricted_value ? item.unrestricted_value : '',
                                value: item.unrestricted_value ? item.unrestricted_value : '',
                                sort: 100
                            };
                        }).filter(item => item.value && item.label).filter(item => (!(existsNames.indexOf(item.name)+1)));
                });
            },
            /**
             * Добавление города
             */
            addCity(city) {
                this.$store.commit('showProgressBar', 'load-price-card');
                city.suggest = true;
                return this.$store.dispatch('cost/addCity', { city: city }).finally(() => this.$store.commit('hideProgressBar', 'load-price-card'));
            },
            /**
             * Выбор города
             */
            async selectCity(id, city) {
                if (!id || id == 'new') city = await this.addCity(city);
                if (!city || !city.id) return;

                this.price.city_id = city.id;
                this.price.city = Object.assign({}, city);
            }
        },
        watch: {
            '$route.params.id'() {
                this.$nextTick(() => this.init());
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DoomPrice.vue?333390c1